import React, { useState } from 'react';
import API_BASE_URL from './config';
import './Login.css';

const ForcePasswordChange = ({ onPasswordChanged, onLogout }) => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const validatePassword = () => {
        if (newPassword.length < 8) {
            return 'Password must be at least 8 characters long';
        }
        if (newPassword !== confirmPassword) {
            return 'Passwords do not match';
        }
        if (currentPassword === newPassword) {
            return 'New password must be different from current password';
        }
        return null;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        // Validate password
        const validationError = validatePassword();
        if (validationError) {
            setError(validationError);
            return;
        }

        setLoading(true);

        try {
            const response = await fetch(`${API_BASE_URL}/auth/change-password`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    current_password: currentPassword,
                    new_password: newPassword
                }),
            });

            const data = await response.json();

            if (response.ok) {
                // Success - password changed
                alert('Password changed successfully!');
                onPasswordChanged();  // Callback to refresh user state
            } else {
                setError(data.detail || 'Failed to change password');
            }
        } catch (err) {
            setError('Network error. Please try again.');
            console.error('Password change error:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999
        }}>
            <div className="login-box" style={{
                maxWidth: '500px',
                width: '90%',
                boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
            }}>
                <h2>Password Change Required</h2>
                <div style={{
                    padding: '15px',
                    background: 'var(--bg-warning, #fff3cd)',
                    border: '1px solid var(--border-warning, #ffc107)',
                    borderRadius: '8px',
                    marginBottom: '20px',
                    color: '#856404'
                }}>
                    <p style={{ margin: 0, fontSize: '14px' }}>
                        For security reasons, you must change your password before continuing.
                        Please choose a strong password that you haven't used before.
                    </p>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="currentPassword">Current Password</label>
                        <input
                            id="currentPassword"
                            type="password"
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                            required
                            placeholder="Enter your current password"
                            autoComplete="current-password"
                            disabled={loading}
                            autoFocus
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="newPassword">New Password</label>
                        <input
                            id="newPassword"
                            type="password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                            placeholder="At least 8 characters"
                            autoComplete="new-password"
                            disabled={loading}
                        />
                        <small style={{ color: 'var(--text-muted)', fontSize: '12px', display: 'block', marginTop: '5px' }}>
                            Minimum 8 characters. Must be different from your current password.
                        </small>
                    </div>

                    <div className="form-group">
                        <label htmlFor="confirmPassword">Confirm New Password</label>
                        <input
                            id="confirmPassword"
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                            placeholder="Re-enter your new password"
                            autoComplete="new-password"
                            disabled={loading}
                        />
                    </div>

                    {error && (
                        <div style={{ 
                            color: '#dc3545', 
                            background: '#fff5f5',
                            padding: '10px',
                            borderRadius: '4px',
                            marginBottom: '15px',
                            fontSize: '14px'
                        }}>
                            {error}
                        </div>
                    )}

                    <div style={{ display: 'flex', gap: '10px' }}>
                        <button 
                            type="submit" 
                            className="login-btn"
                            disabled={loading}
                            style={{ flex: 1 }}
                        >
                            {loading ? 'Changing Password...' : 'Change Password'}
                        </button>
                        <button
                            type="button"
                            onClick={onLogout}
                            className="login-btn"
                            disabled={loading}
                            style={{
                                flex: 0,
                                minWidth: '100px',
                                background: '#6c757d',
                                border: 'none'
                            }}
                        >
                            Logout
                        </button>
                    </div>
                </form>

                <div style={{ marginTop: '20px', padding: '15px', background: 'var(--bg-secondary)', borderRadius: '8px' }}>
                    <p style={{ margin: 0, fontSize: '12px', color: 'var(--text-secondary)' }}>
                        <strong>Password Requirements:</strong>
                    </p>
                    <ul style={{ margin: '10px 0 0 0', paddingLeft: '20px', fontSize: '12px', color: 'var(--text-secondary)' }}>
                        <li>At least 8 characters long</li>
                        <li>Different from your current password</li>
                        <li>Should include a mix of letters, numbers, and symbols</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default ForcePasswordChange;

